module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS6.5dea4b3c.jpg";